module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-about"
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t("about.title")))]), _vm._v(" "), _c('p', {
    staticClass: "text-muted",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('about.primaryText'))
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v(_vm._s(_vm.$t('about.featuredText')))]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v(_vm._s(_vm.$t('about.helpUsText')))]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-outline-warning mb-3",
    attrs: {
      "href": _vm.paypalLink,
      "target": "_blank",
      "rel": "noopener",
      "title": _vm.$t('about.donate')
    },
    on: {
      "click": function($event) {
        _vm.trackClick(_vm.paypalLink)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('about.donate')))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xl-8"
  }, [_c('form', {
    attrs: {
      "action": "https://formspree.io/pulsar.dev.team@gmail.com",
      "method": "POST",
      "name": "sentMessage",
      "id": "contactForm",
      "novalidate": ""
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v(_vm._s(_vm.$t('contact.form.name.label')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "name",
      "placeholder": _vm.$t('contact.form.name.label') + '*',
      "id": "name",
      "required": "",
      "data-validation-required-message": _vm.$t('contact.form.name.validation')
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "help-block text-danger"
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "email"
    }
  }, [_vm._v(_vm._s(_vm.$t('contact.form.email.label')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "name": "_replyto",
      "placeholder": _vm.$t('contact.form.email.label') + '*',
      "id": "email",
      "required": "",
      "data-validation-required-message": _vm.$t('contact.form.email.validation')
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "form-text text-muted",
    attrs: {
      "id": "emailHelp"
    }
  }, [_vm._v(_vm._s(_vm.$t('contact.form.email.helpText')))]), _vm._v(" "), (_vm.email && !_vm.isValidEmail) ? _c('p', {
    staticClass: "help-block text-danger"
  }, [_vm._v(_vm._s(_vm.$t('contact.form.email.error')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "message"
    }
  }, [_vm._v(_vm._s(_vm.$t('contact.form.message.label')))]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.message),
      expression: "message"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "message",
      "placeholder": _vm.$t('contact.form.message.label') + '*',
      "id": "message",
      "rows": "5",
      "required": "",
      "data-validation-required-message": _vm.$t('contact.form.message.validation')
    },
    domProps: {
      "value": (_vm.message)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.message = $event.target.value
      }
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "help-block text-danger"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit",
      "disabled": !_vm.canSubmit()
    }
  }, [_vm._v(_vm._s(_vm.$t('contact.form.submit')))])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "https://www.smashingmagazine.com/2017/10/css-grid-challenge-2017-winners/"
    }
  }, [_c('img', {
    attrs: {
      "src": "static/logo__smashing-magazine--white.svg",
      "alt": "Smashing Magazine",
      "width": "128"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6b294821"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/About.vue
// module id = 645
// module chunks = 1